import {clear_filter, reset_filters_sort} from '@bitstillery/common/lib/filters'
import {get_route} from '@bitstillery/common/lib/utils'

import type {PortalMenuCategory} from '@bitstillery/common/api/fact2server'

import {is_number_list} from '@/lib/filter_selection'

import {collection, filters} from '@/components/pages/offers/offer_list'

/** A parent category filters on itself *and* its children; a leaf on itself alone. */
function category_selection(category: PortalMenuCategory): number[] {
    return [category.artkey, ...category.children.map((child) => child.artkey)]
}

/**
 * The shop URL behind a category menu entry. The category is the only filter in it: the menu is
 * an entry point into the shop, not a refinement of whatever was left selected before — and the
 * link has to mean the same thing when it is copied or opened in a new tab.
 */
export function shop_category_route(category: PortalMenuCategory): string {
    return get_route('/shop', {category: category_selection(category).join(',')})
}

/**
 * Bring the live filter state in line with `shop_category_route`. Navigating there is not enough
 * on its own: the shop page stays mounted across a category click, so nothing re-reads the query
 * params — that only happens when the collection mounts or on a browser back/forward.
 */
export function select_shop_category(category: PortalMenuCategory): void {
    for (const [filter_name, filter] of Object.entries(filters)) {
        if (filter_name !== 'category') {
            clear_filter(filter)
        }
    }
    // Clearing a text filter leaves its `input` — the term is only a filter value once it is
    // submitted — but the search box is where the visitor still *sees* what they searched for.
    filters.search.input = ''

    const selection = filters.category.selection
    if (is_number_list(selection)) {
        selection.splice(0, selection.length, ...category_selection(category))
    }
    filters.category.collapsed = false
}

/**
 * The shop's own reset, behind the `/shop` crumb: what the URL says when nothing is refined. It
 * matches the filter panel's clear control (`reset_filters_sort`) rather than clearing the filters
 * by hand, so "back to the shop" and "clear filters" cannot drift into two different resets.
 */
export function clear_shop_filters(): void {
    void reset_filters_sort(collection)
}
